// Basic
import PropTypes from 'prop-types';
// Components
import Entity from '../../../../common-utils/components/renders/entity/Entity';
import Icon from '../../../../common-utils/components/renders/icon/Icon';
import { Card, CardHeader } from '../../../../common-utils/components/ui/card';
import { Link } from 'react-router-dom';
// Common
import createDataCyAttribute from '../../../../common-utils/functions/createDataCyAttribute';
// Style
import './HomeCard.scss';

/**
 * @param root0
 * @param root0.route
 * @returns {JSX.Element} HomeCard Component
 */
function HomeCard({ route }) {

    // Functions
    const setClassName = () => {
        return route.hidden ? 'card-hidden' : '';
    };

    return (
        <Card data-cy={createDataCyAttribute(route.entity, 'card-')} className={`home-card card-clickable ${setClassName()}`}>
            <Link to={route.url}>
                <CardHeader>
                    <span>
                        {!route.hidden && <Icon icon={route.icon} className='text-primary' />}
                        {!route.hidden && <Entity entity={route.entity} />}
                    </span>
                </CardHeader>
            </Link>
        </Card>
    );
}
HomeCard.propTypes = {
    route: PropTypes.object
};

export default HomeCard;